export enum Path {
  Home = "/",
  Events = "/events",
  Logout = "/logout",
  Admin = "/admin",
  Unknown = "/",
}
